// src/components/RBAC/PermissionGuard.jsx
import React from 'react';
import { usePermissions } from '../../hooks/usePermissions';

const PermissionGuard = ({ 
  permission, 
  children, 
  fallback = null,
  requireAll = false,
  permissions = [] 
}) => {
  const { hasPermission, hasAllPermissions, loading } = usePermissions();
  
  if (loading) {
    return null;
  }
  
  // If single permission
  if (permission) {
    if (!hasPermission(permission)) {
      return fallback;
    }
    return <>{children}</>;
  }
  
  // If multiple permissions
  if (permissions.length > 0) {
    const hasAccess = requireAll 
      ? hasAllPermissions(permissions)
      : permissions.some(p => hasPermission(p));
    
    if (!hasAccess) {
      return fallback;
    }
    return <>{children}</>;
  }
  
  // No permissions required
  return <>{children}</>;
};

export default PermissionGuard;